module.exports = __webpack_public_path__ + "img/117.91513a1a.jpg";